import { useState } from "react";

import PipelineStepContent from "./PipelineStepContent";
import PipelineStepTitle from "./PipelineStepTitle";

export default function PipelineStep({ steps, step, progress }) {
	const [active, setActive] = useState(false);

	const onClick = () => {
		setActive((active) => !active);
	};

	return (
		<>
			<PipelineStepTitle steps={steps} step={step} active={active} progress={progress} onClick={onClick} />

			{active && <PipelineStepContent step={step} progress={progress} />}
		</>
	);
}
